import React, {Component} from "react";
import {Menu, Spin} from 'antd';
import {getDevicesList} from "../../redux_actions/device.action";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {urls} from "../../helper/backend.urls";
import {ReactComponent as IconScanner} from "../../asset/dashboard/scanner.svg";

class ScannersListComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            devices: []
        }
    }

    componentWillMount() {
        this.props.dispatch(getDevicesList())
    }

    render() {

        return this.props.isFetching ?
            [<Spin spinning={true}><Menu.Item onItemHover={null} onClick={null} /></Spin>] :
            [<Menu.ItemGroup {...this.props}>
                {this.props.deviceList.map((device, index) => (
                    index==0 ? 
                        <Menu.Item name={device.name} id={device.id} key={"scanner-" + device.id} {...this.props}>
                        <Link to={urls.current + `/scanners/${device.id}/`}>
                            <span role={"img"} className={"anticon"}>
                                <IconScanner width={"24px"} height={"24px"}/>
                            </span>
                            <span style={{marginLeft: "10px"}}>{device.name}</span>
                        </Link>
                    </Menu.Item> : null
                ))}
            </Menu.ItemGroup>]
    }
}

const mapStateToPropsScannerList = (state) => {
    return {
        isFetching: state.deviceAlert.isFetching,
        deviceList: state.deviceAlert.deviceData
    }
}

export default connect(mapStateToPropsScannerList)(ScannersListComp);
